import { useState } from 'react';

export function useForm(initialValues = {}) {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setValues((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = (callback) => {
    return async (e) => {
      e.preventDefault();
      setErrors({});
      setLoading(true);

      try {
        await callback(values);
      } catch (err) {
        setErrors({ general: err.message || 'An error occurred' });
      } finally {
        setLoading(false);
      }
    };
  };

  const reset = () => {
    setValues(initialValues);
    setErrors({});
    setLoading(false);
  };

  const setError = (field, message) => {
    setErrors((prev) => ({
      ...prev,
      [field]: message
    }));
  };

  return {
    values,
    errors,
    loading,
    handleChange,
    handleSubmit,
    reset,
    setError,
    setValues,
    setLoading
  };
}
